import { HTTP } from '@/services/axios';

export async function getDataToLogin(){
    let result = {};

    var bodyFormData = new FormData();
    
    await HTTP({
        method: 'get',
        url: '/app/core/Common/getDefaultDataLogin.php',
        data: bodyFormData
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getToken(){
    let result = {};

    var bodyFormData = new FormData();
    
    await HTTP({
        method: 'get',
        url: '/app/core/Common/getStoken.php',
        data: bodyFormData
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function loginUser(user){
    let result = {};

    await HTTP({
        method: 'post',
        url: '/app/core/Common/controlLogin.php',
        data: user
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function logoutUser(){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: '/app/core/Common/controlLogout.php'
    })
    .then(response => {
        console.log(response.data)
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}
